import { render, staticRenderFns } from "./FixedIncomeTypeArea.vue?vue&type=template&id=5def6c0c&scoped=true&"
import script from "./FixedIncomeTypeArea.vue?vue&type=script&lang=js&"
export * from "./FixedIncomeTypeArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def6c0c",
  null
  
)

export default component.exports